const DRAFT_KEY = 'yektfard';

const StorageService = {
  getStoreItem (name) {
    if (!name) return;
    return window.localStorage.getItem(name);
  },

  setStoreItem (name, content) {
    if (!name) return;
    if (typeof content !== 'string') {
      content = JSON.stringify(content);
    }
    return window.localStorage.setItem(name, content);
  },

  removeStoreItem (name) {
    if (!name) return;
    return window.localStorage.removeItem(name);
  },

  getDrafts () {
    return this.getStoreItem(DRAFT_KEY);
  },

  saveDraft (value) {
    this.setStoreItem(DRAFT_KEY, value);
  }
};

export { StorageService };
